import React from "react";
import { CABINS } from "../data/cabins";
import { CabinCarousel } from "./CabinCarousel";
import { Check, Bed } from "lucide-react";

const formatBRL = (v) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const Cabins = ({ onSelectCabin }) => {
  return (
    <section
      id="chales"
      data-testid="cabins-section"
      className="py-20 md:py-28 bg-[#f7f5f0]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <p className="text-sm uppercase tracking-[0.2em] text-[#b55a30] font-bold mb-3">
            Nossos chalés
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#1a3622] leading-tight">
            Três refúgios. Uma só natureza.
          </h2>
          <p className="mt-5 text-[#4a6b53] text-base sm:text-lg leading-relaxed">
            Cada acomodação foi pensada para casais que buscam intimidade,
            silêncio e conforto. Café da manhã e jantar inclusos.
          </p>
        </div>

        <div className="flex flex-col gap-20 md:gap-24">
          {CABINS.map((cabin, idx) => (
            <article
              key={cabin.id}
              data-testid={`cabin-card-${cabin.id}`}
              className="grid md:grid-cols-2 gap-8 md:gap-12 items-center"
            >
              <div className={idx % 2 === 1 ? "md:order-2" : ""}>
                <CabinCarousel
                  photos={cabin.photos}
                  name={cabin.name}
                  testIdPrefix={`carousel-${cabin.id}`}
                />
              </div>

              <div className={idx % 2 === 1 ? "md:order-1" : ""}>
                <p className="text-xs uppercase tracking-[0.25em] text-[#b55a30] font-bold mb-2">
                  Chalé {idx + 1}
                </p>
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#1a3622]">
                  {cabin.name}
                </h3>
                <p className="mt-4 text-[#4a6b53] leading-relaxed">
                  {cabin.description}
                </p>

                <div className="mt-6 flex items-baseline gap-2">
                  <span className="text-3xl font-black text-[#1a3622]">
                    {formatBRL(cabin.daily_rate)}
                  </span>
                  <span className="text-sm text-[#4a6b53]">/ diária</span>
                </div>

                <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                  {cabin.amenities.map((a) => (
                    <li
                      key={a}
                      className="flex items-start gap-2 text-sm text-[#1a3622]/85"
                    >
                      <Check className="h-4 w-4 mt-0.5 text-[#1a3622] shrink-0" />
                      <span>{a}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => onSelectCabin(cabin.id)}
                  data-testid={`select-cabin-${cabin.id}`}
                  className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#1a3622] text-[#f7f5f0] px-7 py-3.5 text-sm font-semibold hover:bg-[#2d5638] transition-colors"
                >
                  <Bed className="h-4 w-4" />
                  Reservar este chalé
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
